module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('h1', {
    staticClass: "calibre29",
    attrs: {
      "id": "calibre_pb_8"
    }
  }, [_c('a', {
    staticClass: "calibre5",
    attrs: {
      "id": "_Toc29478518"
    }
  }, [_c('span', {
    staticClass: "calibre30"
  }, [_vm._v("Chapter One")]), _c('br', {
    staticClass: "calibre31"
  }), _c('span', {
    staticClass: "calibre32"
  }, [_vm._v("Alexandria, Egypt")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre11"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The ancient Alexandrian bookstore had been boarded up for decades. As Rebecca inserted her key, the metal lock creaked from lack of use and with a firm shove, the old door gave way, rust flaking from its hinges. Finally, after too long, a warm breeze rushed in and manuscripts fluttered with gratitude. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca closed the door behind her, shutting out the gentle Egyptian breeze and silence settled again over the once bustling bookstore. She frowned at the dust and cobwebs and her nostrils flared as a slight musty smell aroused her senses. Mold, she thought, the enemy of all booklovers. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Stepping cautiously, she glided across the sand that had blown in, and willed her dancer’s legs deeper into her grandmother’s bookstore. Memories flooded back and she sadly muttered, “How I miss you, old woman.” Absent-mindedly, she wiped dust from a thick, leather-bound tome. She")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("then lifted a stack of disintegrating newspapers from a rickety chair and ignoring years of grime, sat down. Seeing a humidor, no doubt filled with the husks of dried out cigars, her olfactory memories ignited a vision of her grandmother dancing with a massive cigar clenched in her teeth.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Tears swelled in Rebecca’s violet eyes. Her head suddenly collapsed into her hands and her pale body shook with emotion.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Wiping away tears, Rebecca recalled that fateful day; she was only eight when her grandmother had passed away. That was thirty years ago and this was the first time she had been able to enter the store bequeathed to her. Previously, even the mere thought of entering the bookstore had been overwhelming. There had been too many memories, too many shared laughs. Rebecca fought her way back to the present where the knowledge she carried was simply too heavy for any one person. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre34"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("***")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca had spent a month cleaning, rearranging and organizing the stock, then another month looking for just the right person to help run the bookstore. Her search had been futile because few knew how to even begin categorizing a tenth of the scattered knowledge. Then one day, a very peculiar man appeared, humbly asking if he might be considered for the position. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He was older, extremely skinny, with sunken eyes that penetrated wherever he looked. Wearing a crumpled light-green shirt, creased grey slacks, and well-worn black loafers, he introduced himself simply as, Akio. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca felt comfortable in his presence and his impressive résumé listed experience at universities in both Kyoto and Tokyo. After rejecting so many applicants, she gratefully hired him.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio’s mornings began early reorganizing manuscripts, then cataloging and referencing until late into the evening. After two months, Rebecca and her new employee had formed a bond of true friendship. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre34"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("***")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Suddenly, one afternoon, Akio tapped the computer screen and excitedly gasped, “Finally! This is what I’ve been waiting for.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca leaned back from the books she was classifying and peered over his shoulder. He pointed at the computer screen while muttering enthusiastically, “Yes. Yes. This is it. At last!”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca read: Will meet you in Nara. Immediately!")]), _c('span', {
    staticClass: "calibre30"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("The email had been sent only hours earlier and she asked, “Why is that particular email of importance to you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Feigning confusion, Akio responded, “It is not important to me at all.”  He smiled. “It is, however, extremely important to you.” This elicited no reaction, so he added, “Well it’s plain, don’t you see?” His skinny finger annoyingly tapped the computer screen. “A message for you to go to Nara -- you must leave immediate -- see, right here, it says -- immediately.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Exasperated, Rebecca muttered, “Why in the world would I go to Nara? That’s in China.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Japan.” Akio corrected.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Fine, Japan! Why would I go there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Because you are no longer needed here. The store is almost ready to reopen and I will be here while you will be there -- meeting whoever sent this email.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Even")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("if I do go to Nara, how will I find who sent this message?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“That will not be a problem. He will find you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“He?” Her eyes searched the email, but it was only a generic address.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio’s eyes focused on the computer screen and for a moment seemed lost in thought. He examined her frustrated face and smiled benevolently. “Just go to Nara. You know you must.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca guffawed. “What in the world makes you think that I must?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“You are one of them. That is why I am here. I know the weight that you carry.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“One of who?” she asked hesitantly. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“A scientist. One of those people who plays in the world of quarks and multiple dimensions. What is that called?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("sighed. “Quantum physics?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Yes.” Akio smiled inwardly. “Quantum mathematics.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("It had been her decision to isolate herself from colleagues within the scientific circle. Her mind was such that it naturally led to constructs larger than itself where great satisfaction lay in the vast world of string theory with its quarks and branes. Nevertheless, there had been a price to pay for that choice, leaving no time for relationships, and she paid for it every day with deep unrelenting loneliness.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca narrowed her eyes and for the first time, Akio noticed that they were cold like amethysts. “How do you know what I do for a living? I’ve never mentioned it.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("He shook his head and shrugged off the question as if it was of no consequence.  ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca wouldn’t let it go and repeated, “How exactly did you know?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“Quantum physics has taught you much. Existence is ethereal. Sometimes the tangible world is here and then simply not here. At the smallest level, material sometimes exists and other times it does not. You are fully aware that things are not as they appear. Are you not?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca clenched her teeth but said nothing. As part of their friendship, she had")]), _c('span', {
    staticClass: "calibre33"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("accepted his annoying habit of asking questions despite already knowing the answer.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("“I know your hobby is astrology. What do the stars tell you?” He had hit a nerve.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca blanched. They had been predicting travel in the future and so much more. He was also right about one other thing -- she was going to go to Nara. Rebecca had always dedicated her life to the search for something larger than herself. The insatiable curiosity that had made her commit to physics had been piqued. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Rebecca admitted to herself that this had the making of an intriguing mystery. Why had Akio been waiting for that specific message and why was he so certain that it was from a male? She seldom turned down an adventure and considering there was still time left on her leave from the university…")]), _c('span', {
    staticClass: "calibre35"
  }), _c('span', {
    staticClass: "calibre3"
  }, [_vm._v("Akio had been right; the store was ready to open and he was more than qualified to oversee its day to day operation. Besides, there was something about Akio that she inherently trusted. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre2"
  }, [_c('span', {
    staticClass: "calibre9",
    attrs: {
      "id": "calibre_pb_9"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06f63f63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0000_split_004.vue
// module id = 72
// module chunks = 0